import React from 'react';
import { Label, Input, FormGroup } from 'reactstrap';

const CrossComponentCheckbox = props => {

    const { formGroup, input } = styles;

    return (
        <FormGroup style={formGroup} >
            <Label for='checkboxInput' style={{ marginBottom: '5px' }}>{props.checkboxLabel}</Label>
            <Input
                type='checkbox'
                id='checkboxInput'
                name='checkboxInput'
                checked={props.isChecked}
                onChange={props.onChange}
                style={input}
            />
        </FormGroup>
    );
}

export default CrossComponentCheckbox;

const styles = {
    formGroup: {
        marginLeft: 20,
        display: 'flex',
        alignItems: 'center'
    },
    input: {
        position: 'relative',
        display: 'flex',
        margin: '0 0 2px 10px'
    }
};


// WEBPACK FOOTER //
// ./src/components/common/stringTemplateRenderer/CrossComponentCheckbox.js